import { MapPin, ShieldCheck, Building2 } from "lucide-react";
import { ARRIVAL_NOTE, ADDRESS, SERVICE_AREA } from "@/config/site";
import { useSeo, localBusinessSchema } from "@/lib/seo";
import { PageHero } from "@/components/common/PageHero";
import { Section } from "@/components/common/Section";
import { Reveal } from "@/components/common/Reveal";
import { VagaroBookingWidget } from "@/components/common/VagaroBookingWidget";
import { LinkButton } from "@/components/common/LinkButton";

export default function Book() {
  useSeo({
    title: "Book Your Legacy Spa Experience | Legacy Spa Houston",
    description:
      "Book your massage or wellness appointment with Legacy Spa in North Houston through our secure Vagaro booking calendar.",
    path: "/book",
    jsonLd: localBusinessSchema,
  });

  return (
    <>
      <PageHero
        eyebrow="Booking"
        titleLines={["Book Your Legacy", "Spa Experience"]}
        lead={`Reserve your in-suite or mobile massage across ${SERVICE_AREA}. Corporate wellness is arranged through a consultation.`}
      />

      <Section className="bg-legacy-charcoal">
        <Reveal>
          <VagaroBookingWidget />
        </Reveal>

        <div className="mx-auto mt-12 max-w-3xl space-y-4">
          <div
            className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/[0.03] p-4 text-sm text-white/70"
            data-testid="book-arrival-note"
          >
            <ShieldCheck className="mt-0.5 h-5 w-5 shrink-0 text-legacy-gold" aria-hidden="true" />
            <p>{ARRIVAL_NOTE}</p>
          </div>
          <div className="flex items-start gap-3 rounded-xl border border-white/10 bg-white/[0.03] p-4 text-sm text-white/70">
            <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-legacy-mint" aria-hidden="true" />
            <p>
              {ADDRESS.line1}, {ADDRESS.line2}, {ADDRESS.city}, {ADDRESS.state}{" "}
              {ADDRESS.zip}
            </p>
          </div>
          <div className="flex flex-col items-start gap-3 rounded-xl border border-legacy-gold/25 bg-legacy-gold/10 p-4 text-sm text-white/75 sm:flex-row sm:items-center sm:justify-between">
            <span className="flex items-start gap-3">
              <Building2 className="mt-0.5 h-5 w-5 shrink-0 text-legacy-gold" aria-hidden="true" />
              Looking for workplace wellness? Corporate services are arranged through a consultation.
            </span>
            <LinkButton
              to="/corporate-wellness#consultation"
              variant="outline"
              size="sm"
              testId="book-corporate-btn"
            >
              Request a Corporate Consultation
            </LinkButton>
          </div>
        </div>
      </Section>
    </>
  );
}
